import { render } from "./LbrxRadioButton.vue?vue&type=template&id=38aab04e&scoped=true"
import script from "./LbrxRadioButton.vue?vue&type=script&lang=js"
export * from "./LbrxRadioButton.vue?vue&type=script&lang=js"

import "./LbrxRadioButton.vue?vue&type=style&index=0&id=38aab04e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38aab04e"]])

export default __exports__